<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Doctor Ledger
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :loading="loadingstatus"
   
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="doctor_ledger(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="orange"
                label
                outlined
                small
                ><v-icon left> mdi-motorbike </v-icon>
                >>
              </v-chip>
            </template>
            <span>Doctor Ledger</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="doctor_statement(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="orange"
                label
                outlined
                small
                >>
              </v-chip>
            </template>
            <span>Doctor Statement</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loadingstatus: true,

      headers: [
        { text: "Doctor Name", value: "dr_name" },
        { text: "Consultation", value: "consultancy_ledger" },
        { text: "Overseas", value: "overseas_ledger" },
        {
          text: "Internal Referral:Received",
          value: "doctor_internal_receive",
        },
        { text: "OT Ledger", value: "ot_ledger" },
        {
          text: "Internal Referral: Transfer",
          value: "doctor_internal_transfer",
        },
        { text: "Refund", value: "patient_refund" },
        { text: "Paid Amount", value: "doctor_paid" },
        { text: "Balance", value: "balance" },
        { text: "Action", value: "actions", sortable: false },
      ],
   

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Doctor ledger",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
  },
  methods: {
    initialize(date) {
      atshq
        .get("doctor-ot-summary?date=" + date)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loadingstatus = false;
          // console.log(this.desserts.length);
        })
        .catch((e) => {
          this.errors.push(e);
        });

      // async / await version (created() becomes async created())
      //
      // try {
      //   const response = await axios.get('http://diqcare-hms-api.local/api/patients')
      //   console.log(response);
      //   this.posts = response.data
      // } catch (e) {
      //   this.errors.push(e)
      // }
    },
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
      // console.log(this.desserts.item);
      alert(item.patient_id);
    },
    doctor_ledger(item) {
      var today = new Date(this.date);
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      window.open(
        this.returnUrl +
          "doctors/doctor_ledger?doctor=" +
          item.id +
          "&start_date=" +
          date +
          "&end_date=" +
          date +
          "&search=Search/"
      );
    },
    doctor_statement(item) {
      var today = new Date(this.date);
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      window.location.href =
        
        "doctor-statement?doctor_id=" +
        item.id +
        "&date=" +
        date +
        "&search=Search";
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
  },
};
</script>